//import React from 'react';
//import PropTypes from 'prop-types';

export default function Translate(props) {
    if (!props.children) return null;
    return props.children.pl || props.children;
}